<template>
  <div>
    <b-row>
      <b-col cols="3">
        <b-card-img
          :src="dataDetail.cover_url"
          alt="Image"
          class="rounded-0"
        />
      </b-col>
      <b-col cols="9">
        <b-row>
          <b-col cols="12">
            <h4>{{ dataDetail.name }}</h4>
          </b-col>
          <b-col cols="3">
            <p>Tác giả</p>
            <p>Nhà xuất bản</p>
            <p>Chủ đề</p>
            <p>Thể loại</p>
            <p>Ngôn ngữ</p>
          </b-col>
          <b-col cols="9">
            <p>{{ dataDetail.authors.map(author => author.name).join(", ") }}</p>
            <p>{{ dataDetail.publisher_name }}</p>
            <p>{{ dataDetail.categories.map(author => author.name).join(", ") }}</p>
            <p>{{ dataDetail.genres.map(author => author.name).join(", ") }}</p>
            <p>{{ dataDetail.language_name }}</p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCardImg,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  name: 'FormDocument',
  components: {
    BRow,
    BCol,
    BCardImg,
  },
  props: {
    dataSendForm: {
      anPhamId: null,
    },
  },
  data() {
    return {
      dataDetail: {},
    }
  },
  computed: {
    // calculate data from init data
  },
  watch: {
    // listening change data init
  },
  async created() {
    // init data FROM API
    if (this.dataSendForm.anPhamId) {
      const data = await this.getInfoPublication({ anPhamId: this.dataSendForm.anPhamId })
      this.dataDetail = data
    }
  },
  methods: {
    ...mapActions({
      getInfoPublication: 'digitalLibrary/getInfoPublication',
    }),
  },
}
</script>

<style scoped>
</style>
